export enum MatchStatusesEnum {
    Created = 0,
    InProgress = 1, 
    Ended = 2
}